/**
 ********** Pure js ACCORDION with wcag  **********
 */
import classes from './variables/variables.js';

/**
 * Initializes accordion functionality by adding click and keydown event listeners to accordion headers.
 */
export function Accordion() {
    const accordion = document.querySelectorAll(`.${classes.ACCORDION_HEAD}`);

    accordion.forEach((button) => {
        button.addEventListener('click', () => { toggleAccordion(button) });
        button.addEventListener('keydown', handleAccordionKeyPress);
    });
}

/**
 * Toggles the accordion open/closed state when an accordion header is clicked.
 */
function toggleAccordion(button) {
    const item = button.closest(`.${classes.ACCORDION_ITEM}`);
    if (!item) {
        return;
    }

    const root = item.parentElement;
    if (!root) {
        return;
    }

    if (item.classList.contains(classes.OPEN_ACCORDION)) {
        item.classList.remove(classes.OPEN_ACCORDION);
        button.setAttribute('aria-expanded', 'false');
    } else {
        item.classList.add(classes.OPEN_ACCORDION);
        button.setAttribute('aria-expanded', 'true');
    }

    Array.from(root.children).forEach((child) => {
        if (!child.classList.contains(classes.ACCORDION_ITEM) || child === item) {
            return;
        }
        child.classList.remove(classes.OPEN_ACCORDION);
        const otherButton = child.querySelector(`.${classes.ACCORDION_HEAD}`);
        if (otherButton) {
            otherButton.setAttribute('aria-expanded', 'false');
        }
    });
}

/**
 * Handles keydown events for accordion headers to support keyboard navigation.
 */
function handleAccordionKeyPress(event) {
    const key = event.key || event.code;
    if (key === ' ' || key === 'Enter') { // Check for Space or Enter key
        event.preventDefault(); // Prevent default action (e.g., scrolling for Space key)
        const button = event.target.closest(`.${classes.ACCORDION_HEAD}`);
        if (button) {
            toggleAccordion(button);
        }
    }
}
